// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2ymzw","row":"styles_row__IarcP"};